import RightArrowHead from '../../../../general/icon/components/right-arrow-head';
import styles from './arrow.module.scss';

export const Arrow = () => (
  <div className={styles['arrow']}>
    <RightArrowHead />
  </div>
);
